import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * Layout owns DOM slots; ChatAssistant portals Recents into them.
 * Session state remains owned by ChatAssistant — presentation bridge only.
 */
const ChatNavSlotsContext = createContext({
  recentsSlot: null,
  setRecentsSlot: (_el) => {},
  navCollapsed: false,
});

export function ChatNavSlotsProvider({ children, navCollapsed = false }) {
  const [recentsSlot, setRecentsSlot] = useState(null);
  const value = useMemo(
    () => ({
      recentsSlot,
      setRecentsSlot,
      navCollapsed,
    }),
    [recentsSlot, navCollapsed],
  );
  return (
    <ChatNavSlotsContext.Provider value={value}>
      {children}
    </ChatNavSlotsContext.Provider>
  );
}

export function useChatNavSlots() {
  return useContext(ChatNavSlotsContext);
}

/** Custom event: Layout New Chat → ChatAssistant.startNewChat (same handler). */
export const CHAT_REQUEST_NEW_CHAT_EVENT = "chat:requestNewChat";

const PENDING_NEW_CHAT_KEY = "chat_request_new_chat";

/** Call from Layout New Chat — works whether ChatAssistant is already mounted or not. */
export function requestNewChat() {
  try {
    sessionStorage.setItem(PENDING_NEW_CHAT_KEY, "1");
  } catch {
    // ignore
  }
  try {
    window.dispatchEvent(new CustomEvent(CHAT_REQUEST_NEW_CHAT_EVENT));
  } catch {
    // ignore
  }
}

/** ChatAssistant consumes a pending New Chat request after mount/navigation. */
export function consumePendingNewChat() {
  try {
    if (sessionStorage.getItem(PENDING_NEW_CHAT_KEY) === "1") {
      sessionStorage.removeItem(PENDING_NEW_CHAT_KEY);
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}
